// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__cZlRD","Logo":"Toolbar_Logo__11RPj","DesktopOnly":"Toolbar_DesktopOnly__2XieZ"};